import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Container,
  Typography,
  Rating,
  Stack,
  IconButton,
  Paper,
  Chip,
  Tabs,
  Tab,
  Button,
  TextField,
  InputAdornment,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Checkbox,
  ListItemText,
  Slider,
  Dialog,
  DialogTitle,
  DialogContent,
  MobileStepper,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SearchIcon from "@mui/icons-material/Search";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
// import GoogleIcon from '@mui/icons-material/Google';
import GoogleIcon from "../../images/google_image.png"
import filterIcon from "../../images/icons8-filter-50 (1).png"
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from 'dayjs';
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Popper from "@mui/material/Popper";
import { searchAPI } from "../../API/Seach"; // Adjust the path according to your project structure
import { debounce } from "lodash";
import { toast } from "react-hot-toast";
import TravelersModal from "../Modals/TravellerModal";
import Loader from "../Loader";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { tokens } from "../../theme/tokens";


// Custom Tab Panel Component
function CustomTabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box sx={{ py: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const GALLERY_ROW_PATTERN = [3, 2, 3, 1];

function buildGalleryRows(images = [], pattern = []) {
  if (!Array.isArray(images) || !images.length) return [];
  if (!Array.isArray(pattern) || !pattern.length) return [];

  const rows = [];
  let cursor = 0;
  let patternIdx = 0;

  while (cursor < images.length) {
    const patternCols = pattern[patternIdx % pattern.length];
    const slice = images.slice(cursor, cursor + patternCols);
    if (!slice.length) break;

    rows.push({
      images: slice,
      columnCount: slice.length,
      startIndex: cursor,
    });
    cursor += patternCols;
    patternIdx += 1;
  }

  return rows;
}

const MAIN_STEPPER_DOTS = 3;

const getModalRowItemWidth = (columnCount) => {
  if (columnCount === 1) return { xs: "88%", sm: "72%" };
  if (columnCount === 2) return { xs: "calc(50% - 4px)", sm: "calc(50% - 6px)" };
  return { xs: "calc(33.333% - 6px)", sm: "calc(33.333% - 8px)" };
};

const getModalImageHeight = (columnCount) => {
  if (columnCount === 1) return { xs: 180, sm: 220 };
  if (columnCount === 2) return { xs: 140, sm: 170 };
  return { xs: 110, sm: 140 };
};

const modalImageTileSx = {
  borderRadius: "8px",
  overflow: "hidden",
  bgcolor: tokens.surfaceAlt,
  border: "1px solid",
  borderColor: tokens.border,
  flexShrink: 0,
};

const HotelDetailsPage = () => {
  const [galleryModalOpen, setGalleryModalOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  // For hotel details, searchResults is the .data object from /api/Hotel/HotelDetails
  // shape: { query, hotelId, hotel, availableRooms, ... }
  const { searchResults, locationName } = location.state || {};
  const hotelInfo = searchResults?.hotel;

  console.log(hotelInfo, "sumitttttttttttttttttttttttttttt")

  const [whereToValue] = useState(locationName || "");
  const [checkInDate, setCheckInDate] = useState(() => {
    if (searchResults?.query?.checkIn) {
      return dayjs(searchResults.query.checkIn);
    }
    return dayjs(); // Default to today
  });
  const [checkOutDate, setCheckOutDate] = useState(() => {
    if (searchResults?.query?.checkOut) {
      return dayjs(searchResults.query.checkOut);
    }
    return dayjs().add(1, 'day'); // Default to tomorrow
  });
  const [travelers, setTravelers] = useState(() => {
    if (searchResults?.query?.occupancies) {
      const totalAdults = searchResults.query.occupancies.reduce(
        (sum, occ) => sum + (occ.numOfAdults || 0),
        0
      );
      return `${totalAdults} travelers, ${searchResults.query.occupancies.length} room`;
    }
    return "1 travelers, 1 room";
  });

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Build image objects from new hotel images list
  const filteredImages = (hotelInfo?.images || [])
    .map((img) =>
      typeof img === "string" ? { url: img } : { url: img?.url || "" }
    )
    .filter((img) => Boolean(img.url));

  const fallbackGalleryImages = [
    {
      url: "https://plus.unsplash.com/premium_photo-1661929519129-7a76946c1d38?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      url: "https://images.unsplash.com/photo-1549294413-26f195200c16?q=80&w=1964&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      url: "https://plus.unsplash.com/premium_photo-1687960116497-0dc41e1808a2?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      url: "https://images.unsplash.com/photo-1596701062351-8c2c14d1fdd0?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
  ];

  const galleryImages = useMemo(() => {
    const images = filteredImages.length ? filteredImages : fallbackGalleryImages;
    return Array.isArray(images) ? images : [];
  }, [filteredImages]);

  const galleryRows = useMemo(
    () => buildGalleryRows(galleryImages, GALLERY_ROW_PATTERN),
    [galleryImages]
  );

  const handleNext = () => {
    setActiveStep((prevStep) =>
      prevStep === galleryImages.length - 1 ? 0 : prevStep + 1
    );
  };

  const handleBack = () => {
    setActiveStep((prevStep) =>
      prevStep === 0 ? galleryImages.length - 1 : prevStep - 1
    );
  };

  const remainingPhotos = Math.max(0, galleryImages.length - 3);

  const mainStepperSteps = useMemo(() => {
    if (galleryImages.length <= 1) return 0;
    return Math.min(MAIN_STEPPER_DOTS, galleryImages.length);
  }, [galleryImages.length]);

  const mainStepperActiveStep = useMemo(() => {
    if (galleryImages.length <= 1) return 0;
    if (galleryImages.length <= MAIN_STEPPER_DOTS) return activeStep;
    return Math.min(
      MAIN_STEPPER_DOTS - 1,
      Math.round((activeStep / (galleryImages.length - 1)) * (MAIN_STEPPER_DOTS - 1))
    );
  }, [activeStep, galleryImages.length]);

  const [sideImage1] = useState(() => {
    const pool = filteredImages.length ? filteredImages : fallbackGalleryImages;
    const randomIndex = Math.floor(Math.random() * (pool.length || 1));
    return pool[randomIndex]?.url || fallbackGalleryImages[0].url;
  });

  const [sideImage2] = useState(() => {
    const pool = filteredImages.length ? filteredImages : fallbackGalleryImages;
    const randomIndex = Math.floor(Math.random() * (pool.length || 1));
    return pool[randomIndex]?.url || fallbackGalleryImages[1].url;
  });

  // Map new hotel payload into UI-friendly structure
  const hotelData = {
    name: hotelInfo?.name || "Hotel",
    starRating: hotelInfo?.starRating || "4",
    rating: hotelInfo?.reviews?.rating || "0",
    reviews: hotelInfo?.reviews?.count || "0",
    location: hotelInfo
      ? `${hotelInfo.address?.city || ""}${hotelInfo.address?.city ? ", " : ""}${
          hotelInfo.address?.country || ""
        }`
      : "",
    about:
      hotelInfo?.description ||
      "Relax in our thoughtfully designed rooms with modern amenities.",
    quickFacts: {
      checkIn: searchResults?.details?.aboutHotel?.checkinInfo?.beginTime || "12:00 PM",
      checkOut: searchResults?.details?.aboutHotel?.checkoutInfo?.time || "12:00 PM",
      rooms: "42",
      floors: "5"
    },
    images: galleryImages,
    amenities: hotelInfo?.amenities || [],
  };

  // Map new availableRooms into a recommendations-like structure used by existing UI (memoized to avoid infinite useEffect loops)
  const legacyRecommendations = useMemo(() => {
    return (
      searchResults?.details?.roomAndRates?.recommendations ||
      (searchResults?.availableRooms
        ? searchResults.availableRooms.map(rec => ({
            recommendationId: rec.recommendationId,
            finalRate: rec.totalPrice,
            currency: rec.currency,
            rooms: (rec.rooms || []).map(room => {
              const primaryRate = (room.rates && room.rates[0]) || null;
              const occupancies =
                primaryRate?.occupancy
                  ? [
                      {
                        numOfAdults: primaryRate.occupancy.adults,
                        numOfChildren: primaryRate.occupancy.children,
                      },
                    ]
                  : [];

              return {
                standardizedRoomName: room.standardizedRoomName || room.roomName,
                roomName: room.roomName,
                roomId: room.roomId,
                rateId: primaryRate?.rateId,
                recommendationId: room.recommendationId,
                image:
                  room.roomImage ||
                  hotelInfo?.heroImage ||
                  (hotelInfo?.images && hotelInfo.images[0]) ||
                  "",
                beds: room.beds || [],
                facilities: room.amenities || [],
                category:
                  primaryRate?.boardDescription || primaryRate?.boardType || "",
                refundable: primaryRate?.isRefundable ?? false,
                freeCancellation: false,
                refundableStatus: primaryRate?.isRefundable
                  ? "Refundable"
                  : "Non-Refundable",
                finalRate: primaryRate?.finalRate ?? rec.totalPrice,
                occupancy: primaryRate?.occupancy || null,
                occupancies,
                cancellationPolicies: primaryRate?.cancellationPolicies || [],
              };
            }),
          }))
        : undefined)
    );
  }, [searchResults]);

  // Add these new state variables
  const [searchText, setSearchText] = useState(locationName || "");
  const [locationSearchResults, setLocationSearchResults] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(() => {
    if (searchResults?.query?.locationId) {
      return {
        id: searchResults.query.locationId,
        name: locationName,
        type: "City"
      };
    }
    return null;
  });

  // Add these new state variables
  const [openTravelersModal, setOpenTravelersModal] = useState(false);
  const [travelersData, setTravelersData] = useState(() => {
    if (searchResults?.query?.occupancies) {
      const totalAdults = searchResults.query.occupancies.reduce(
        (sum, occ) => sum + (occ.numOfAdults || 0),
        0
      );
      const totalChildren = searchResults.query.occupancies.reduce(
        (sum, occ) => sum + (occ.childAges?.length || 0),
        0
      );
      return {
        adults: totalAdults,
        children: totalChildren,
        rooms: searchResults.query.occupancies.length,
        childAges: searchResults.query.occupancies[0]?.childAges || [] // Add childAges from the first occupancy
      };
    }
    return {
      adults: 1,
      children: 0,
      rooms: 1,
      childAges: [] // Add empty childAges array for initial state
    };
  });

  // Add this handler
  const handleTravelersChange = (newTravelers) => {
    setTravelersData(newTravelers);
    setTravelers(`${newTravelers.adults + newTravelers.children} travelers, ${newTravelers.rooms} room${newTravelers.rooms > 1 ? 's' : ''}`);
  };

  // Add these new functions
  const handleSearch = debounce(async (text) => {
    if (text.length >= 3) {
      setLoading(true);
      try {
        const response = await searchAPI.searchLocation(text);
        const locations = response?.data?.locations || [];

        if (response.status === "success" && response.statusCode === 200) {
          setLocationSearchResults(locations);
        } else {
          setLocationSearchResults([]);
        }
      } catch (error) {
        console.error("Search failed:", error);
        setLocationSearchResults([]);
      } finally {
        setLoading(false);
      }
    } else {
      setLocationSearchResults([]);
    }
  }, 300);

  const handleSearchTextChange = (e) => {
    const newValue = e.target.value;
    setSearchText(newValue);
    if (newValue === "") {
      setSelectedLocation(null);
    }
    setAnchorEl(e.currentTarget);
    handleSearch(newValue);
  };

  const handleLocationSelect = (location) => {
    setSearchText(location.name);
    setSelectedLocation(location);
    setLocationSearchResults([]);
    setAnchorEl(null);
  };

  // Add navigate
  const navigate = useNavigate();

  // Add this function to handle hotel search
  const handleSearchHotels = async () => {
    if (!selectedLocation) {
      toast.error("Please select a location from the dropdown");
      return;
    }

    const searchParams = {
      locationId: selectedLocation.type !== "Hotel" ? parseInt(selectedLocation.id) : 0,
      hotelId: selectedLocation.type === "Hotel" ? [selectedLocation.id.toString()] : [],
      checkIn: checkInDate.format("YYYY-MM-DD"),
      checkOut: checkOutDate.format("YYYY-MM-DD"),
      occupancies: Array(travelersData.rooms).fill({
        numOfAdults: Math.ceil(travelersData.adults / travelersData.rooms),
        childAges: travelersData.childAges || [] // Use actual child ages from travelersData
      }),
      filterBy: {
        ratings: null,
        freeBreakfast: false,
        isRefundable: false,
        subLocationIds: null,
        facilities: null,
        type: null,
        tags: null,
        reviewRatings: null,
        minPrice: 0,
        maxPrice: 0
      },
      page: 1,
      traceId: null,
    };

    setIsLoading(true);
    try {
      const response = await searchAPI.searchHotels(searchParams);

      if (response.status === "success" && response.statusCode === 200) {
        navigate("/search", {
          state: {
            // pass full data object: { query, totalPages, currentPage, totalCount, data: [...] }
            searchResults: response.data,
            locationName: selectedLocation.name,
            searchParams: {
              location: selectedLocation,
              checkIn: checkInDate.format("YYYY-MM-DD"),
              checkOut: checkOutDate.format("YYYY-MM-DD"),
              travelers: travelersData, // Pass the complete travelersData
            },
          },
        });
      } else {
        throw new Error(response.message || "Search failed");
      }
    } catch (error) {
      console.error("Failed to search hotels:", error);
      toast.error("Failed to search hotels. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // Add date validation functions
  const isCheckInDateValid = (date) => {
    const today = dayjs().startOf('day');
    return date.isSame(today) || date.isAfter(today);
  };

  const isCheckOutDateValid = (date) => {
    return date.isAfter(checkInDate);
  };

  // Add date change handlers
  const handleCheckInDateChange = (newDate) => {
    if (newDate) {
      setCheckInDate(newDate);
      // If check-out date is before or same as new check-in date
      if (!checkOutDate.isAfter(newDate)) {
        setCheckOutDate(newDate.add(1, 'day'));
      }
    }
  };

  const handleCheckOutDateChange = (newDate) => {
    if (newDate) {
      setCheckOutDate(newDate);
    }
  };

  // Filter states
  const [filteredRecommendations, setFilteredRecommendations] = useState([]);
  const [selectedMealTypes, setSelectedMealTypes] = useState([]);
  const [selectedRefundableStatus, setSelectedRefundableStatus] = useState([]);
  const [priceRange, setPriceRange] = useState([0, 1500000]); // 0 to 15 lakh
  const [availableMealTypes, setAvailableMealTypes] = useState([]);
  const [availableRefundableStatus, setAvailableRefundableStatus] = useState([]);
  const [minPrice] = useState(0); // Fixed minimum price
  const [maxPrice] = useState(1500000); // Fixed maximum price (15 lakh)

  // Extract filter options from room data
  useEffect(() => {
    if (legacyRecommendations && legacyRecommendations.length) {
      const recommendations = legacyRecommendations;
      
      // Extract meal types and refundable statuses
      const mealTypes = new Set();
      const refundableStatuses = new Set();

      recommendations.forEach(recommendation => {
        recommendation.rooms.forEach(room => {
          // Extract meal types from room category
          if (room.category) {
            const categories = room.category.split(',').map(cat => cat.trim());
            categories.forEach(cat => {
              // Skip "Room" as it's not a meal type
              if (cat !== 'Room' && cat !== '') {
                // Clean up the meal type names
                let cleanMealType = cat;
                if (cat === 'Breakfast') cleanMealType = 'Breakfast';
                else if (cat === 'Lunch/Dinner') cleanMealType = 'Lunch/Dinner';
                else if (cat === 'Only') cleanMealType = 'Room Only';
                else if (cat === 'FullBoard') cleanMealType = 'Full Board';
                else if (cat === 'HalfBoard') cleanMealType = 'Half Board';
                else if (cat.toLowerCase().includes('full board')) cleanMealType = 'Full Board';
                else if (cat.toLowerCase().includes('half board')) cleanMealType = 'Half Board';
                
                mealTypes.add(cleanMealType);
              }
            });
          }

          // Extract refundable status
          if (room.refundable !== undefined) {
            refundableStatuses.add(room.refundable ? 'Refundable' : 'Non-Refundable');
          }
        });
      });


      // Convert to arrays and sort
      const sortedMealTypes = Array.from(mealTypes).sort();
      const sortedRefundableStatuses = Array.from(refundableStatuses).sort();

      // Debug logging
      console.log('Extracted Meal Types:', sortedMealTypes);
      console.log('Extracted Refundable Statuses:', sortedRefundableStatuses);

      setAvailableMealTypes(sortedMealTypes);
      setAvailableRefundableStatus(sortedRefundableStatuses);
      
      // Initialize filtered recommendations
      setFilteredRecommendations(recommendations);
    }
  }, [legacyRecommendations]);

  // Filter recommendations based on selected filters
  useEffect(() => {
    if (legacyRecommendations && legacyRecommendations.length) {
      let filtered = legacyRecommendations.filter(recommendation => {
        // Filter by meal types
        if (selectedMealTypes.length > 0) {
          const hasMatchingMealType = recommendation.rooms.some(room => {
            if (!room.category) return false;
            const categories = room.category.split(',').map(cat => cat.trim());
            
            // Check if any selected meal type matches the room's categories
            return selectedMealTypes.some(selectedMeal => {
              // Handle special cases for matching
              if (selectedMeal === 'Room Only') {
                return categories.includes('Only') || room.category === 'Room Only';
              } else if (selectedMeal === 'Breakfast') {
                return categories.includes('Breakfast');
              } else if (selectedMeal === 'Lunch/Dinner') {
                return categories.includes('Lunch/Dinner');
              } else if (selectedMeal === 'Full Board') {
                return categories.includes('FullBoard') || 
                       categories.some(cat => cat.toLowerCase().includes('full board'));
              } else if (selectedMeal === 'Half Board') {
                return categories.includes('HalfBoard') || 
                       categories.some(cat => cat.toLowerCase().includes('half board'));
              }
              return false;
            });
          });
          if (!hasMatchingMealType) return false;
        }

        // Filter by refundable status
        if (selectedRefundableStatus.length > 0) {
          const hasMatchingRefundableStatus = recommendation.rooms.some(room => {
            const roomRefundableStatus = room.refundable ? 'Refundable' : 'Non-Refundable';
            return selectedRefundableStatus.includes(roomRefundableStatus);
          });
          if (!hasMatchingRefundableStatus) return false;
        }

        // Filter by price range
        const roomPrice = recommendation.finalRate;
        if (roomPrice < priceRange[0] || roomPrice > priceRange[1]) {
          return false;
        }

        return true;
      });

      setFilteredRecommendations(filtered);
    }
  }, [selectedMealTypes, selectedRefundableStatus, priceRange, legacyRecommendations]);

  const handleBookRoom = async (roomData) => {
    try {
      const recommendation = (legacyRecommendations || []).find(
        rec => rec.recommendationId === roomData.recommendationId
      );

      if (!recommendation) {
        throw new Error("Recommendation not found");
      }

      const itineraryCode = searchResults?.itinerary?.[0]?.code;
      const items = searchResults?.items || [];
      if (!itineraryCode) {
        toast.error("Itinerary not found. Please go back and try again.");
        return;
      }
      if (!items.length) {
        toast.error("Booking items not found. Please go back and try again.");
        return;
      }

      const payload = {
        query: searchResults.query,
        traceId: searchResults.traceId || "",
        recommendationId: roomData.recommendationId,
        rooms: recommendation.rooms.map((room, index) => ({
          rateId: room.rateId,
          roomId: room.roomId,
          occupancy: {
            adults: room.occupancy?.adults ?? searchResults.query?.occupancies?.[index]?.numOfAdults ?? searchResults.query?.occupancies?.[0]?.numOfAdults ?? 1,
            childAges: room.occupancy?.childAges ?? searchResults.query?.occupancies?.[index]?.childAges ?? searchResults.query?.occupancies?.[0]?.childAges ?? []
          }
        })),
        items: items.map(item => ({ code: item.code, type: item.type || "HOTEL" }))
      };

      setIsLoading(true);
      const response = await searchAPI.selectItineraryRoom(itineraryCode, payload);
      const isSuccess =
        response &&
        (response.status === "success" && (Number(response.statusCode) === 200 || response.statusCode === "200")) ||
        (response.data?.itineraryCode != null) ||
        (response.itineraryCode != null);
      const bookingPayload = response?.data ?? response;
      if (isSuccess && bookingPayload) {
        toast.success(response.message || "Room selected successfully!");
        const guestCount = searchResults?.query?.occupancies?.reduce(
          (s, o) => s + (o.numOfAdults || 0) + (o.childAges?.length || 0),
          0
        ) || 0;
        const roomNames = (recommendation.rooms || []).map(
          (r) => r.standardizedRoomName || r.roomName || "Room"
        );
        const selectedRooms = recommendation.rooms.map((room, index) => ({
          rateId: room.rateId,
          roomId: room.roomId,
          occupancy: {
            adults:
              room.occupancy?.adults ??
              searchResults.query?.occupancies?.[index]?.numOfAdults ??
              searchResults.query?.occupancies?.[0]?.numOfAdults ??
              1,
            childAges:
              room.occupancy?.childAges ??
              searchResults.query?.occupancies?.[index]?.childAges ??
              searchResults.query?.occupancies?.[0]?.childAges ??
              [],
          },
          roomName: room.standardizedRoomName || room.roomName || "Room",
        }));

        navigate("/guest-detail", {
          state: {
            bookingDetails: bookingPayload,
            hotelInfo: searchResults?.hotel,
            selectedRoomSummary: {
              roomName:
                roomNames.length > 1
                  ? `${roomNames.length} rooms`
                  : roomNames[0] || "Room",
              roomNames,
              totalPrice: recommendation?.finalRate ?? recommendation?.totalPrice,
              currency: recommendation?.currency || "INR",
              guestCount,
              roomId: recommendation?.rooms?.[0]?.roomId,
              rateId: recommendation?.rooms?.[0]?.rateId,
              selectedRooms,
            },
          },
        });
      } else {
        toast.error(response?.message || "Failed to select room. Please try again.");
      }
    } catch (error) {
      console.error("Room selection error:", error);
      toast.error(error?.response?.data?.message || "Failed to select room. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
       {isLoading && <Loader />}
    <Box sx={{  minHeight: "100vh", py: 4, mt: 2, }}>
      <style>
        {`
          @media (min-width: 0px) {
            .css-hv01y4-MuiPaper-root {
              padding: 2px !important;
            }
          }
        `}
      </style>
      <Container 
          maxWidth="xl"
          sx={{ 
            px: { xs: 2, sm: 3, md: 4 },
            py: 3,
            bgcolor: 'white',
            borderRadius: 2,
            boxShadow: '0 0 20px rgba(0,0,0,0.05)',
          }}
        >
        {/* Hotel Name and Rating Section */}
        <Paper 
            elevation={0} 
            sx={{ 
              p: { xs: 2, sm: 3 },
              mb: 3,
              // Removed ml: 8, mr: 8 - Rely on Container padding
              borderColor: 'divider',
              borderRadius: 2
            }}
          >
          <Typography variant="h4" component="h1" sx={{ mb: 2 , fontSize: "24px",}}>
            {hotelData.name}
          </Typography>

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            spacing={{ xs: 4, sm: 3 }}
            sx={{ color: "text.secondary" }}
          >
            <Stack 
              direction={{ xs: 'column', sm: 'row' }} 
              alignItems={{ xs: 'flex-start', sm: 'center' }} 
              spacing={{ xs: 1, sm: 2 }}
              sx={{ width: { xs: '100%', sm: 'auto' } }}
            >
              {/* Hotel Star Rating */}
              <Rating 
                value={Number(hotelData.starRating)} 
                readOnly 
                max={5}
                sx={{ color: tokens.highlight }}
              />
              
              {/* Google Rating */}
              <Stack 
                direction={{ xs: 'column', sm: 'row' }} 
                alignItems={{ xs: 'flex-start', sm: 'center' }} 
                spacing={{ xs: 0.5, sm: 1 }}
                sx={{ 
                  flexWrap: 'wrap',
                  gap: { xs: 0.5, sm: 1 }
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Box
                    component="img"
                    src={GoogleIcon}
                    alt="Google"
                    sx={{
                      width: '20px',
                      height: '20px',
                      objectFit: 'contain'
                    }}
                  />
                  <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                    {hotelData.rating}/5
                  </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  ({hotelData.reviews} Reviews)
                </Typography>
                </Stack>
                                     <Stack 
              direction="row" 
              alignItems="center" 
              spacing={1}
              sx={{ 
                width: { xs: '100%', sm: 'auto' },
                minWidth: 0,
                flex: 1,
              }}
            >
              <LocationOnIcon fontSize="small" sx={{ flexShrink: 0 }} />
              <Typography 
                variant="body2" 
                sx={{ 
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                  hyphens: 'auto'
                }}
              >
                {hotelData.location}
              </Typography>
            </Stack>
              </Stack>
 
            </Stack>

    
          </Stack>
        </Paper>

      <Box
        sx={{
          display: { xs: 'block', sm: 'none' }, // only show on xs (mobile)
          height: '1px',
          backgroundColor: tokens.surfaceAlt,
          my: 1, // vertical spacing
        }}
      />


        {/* Image Gallery Section */}
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, sm: 3 },
            mb: 3,
            borderColor: "divider",
            borderRadius: 2,
          }}
        >
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={1}
            sx={{ height: { xs: "auto", md: 450 } }}
          >
            <Box
              sx={{
                flex: { xs: "1 1 auto", md: "1 1 60%" },
                position: "relative",
                borderRadius: "8px",
                overflow: "hidden",
                height: { xs: 300, sm: 400, md: "100%" },
                width: "100%",
              }}
            >
              <Box
                component="img"
                src={
                  galleryImages[activeStep]?.url ||
                  "https://images.unsplash.com/photo-1566665797739-1674de7a421a?q=80&w=1974&auto=format&fit=crop"
                }
                alt={`${hotelData.name} — photo ${activeStep + 1}`}
                sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
              {galleryImages.length > 1 && (
                <>
                  <IconButton
                    onClick={handleBack}
                    sx={{
                      position: "absolute",
                      left: 8,
                      top: "50%",
                      transform: "translateY(-50%)",
                      bgcolor: "rgba(255, 255, 255, 0.9)",
                      "&:hover": { bgcolor: "white" },
                    }}
                  >
                    <NavigateBeforeIcon />
                  </IconButton>
                  <IconButton
                    onClick={handleNext}
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: "50%",
                      transform: "translateY(-50%)",
                      bgcolor: "rgba(255, 255, 255, 0.9)",
                      "&:hover": { bgcolor: "white" },
                    }}
                  >
                    <NavigateNextIcon />
                  </IconButton>
                  <MobileStepper
                    steps={mainStepperSteps}
                    position="static"
                    activeStep={mainStepperActiveStep}
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      width: "100%",
                      bgcolor: "transparent",
                      "& .MuiMobileStepper-dots": {
                        maxWidth: 72,
                        overflow: "hidden",
                        justifyContent: "center",
                      },
                      "& .MuiMobileStepper-dot": {
                        bgcolor: "rgba(255, 255, 255, 0.5)",
                        width: 8,
                        height: 8,
                        margin: "0 4px",
                        flexShrink: 0,
                      },
                      "& .MuiMobileStepper-dotActive": {
                        bgcolor: "white",
                      },
                      display: "flex",
                      justifyContent: "center",
                      padding: "16px 0",
                    }}
                    backButton={null}
                    nextButton={null}
                  />
                </>
              )}
            </Box>

            <Stack
              sx={{
                flex: { xs: "1 1 auto", md: "1 1 40%" },
                maxWidth: { xs: "100%", md: "424px" },
                display: { xs: "none", sm: "flex" },
                flexDirection: { xs: "row", sm: "column" },
                gap: 1,
              }}
            >
              <Box sx={{ height: "220px", borderRadius: "8px", overflow: "hidden" }}>
                <Box
                  component="img"
                  src={sideImage1}
                  alt="Hotel view 1"
                  sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                />
              </Box>
              <Box
                onClick={() => remainingPhotos > 0 && setGalleryModalOpen(true)}
                sx={{
                  height: { xs: 150, sm: 220 },
                  flex: { xs: 1, sm: "none" },
                  borderRadius: "8px",
                  overflow: "hidden",
                  position: "relative",
                  cursor: remainingPhotos > 0 ? "pointer" : "default",
                }}
              >
                <Box
                  component="img"
                  src={sideImage2}
                  alt="Hotel view 2"
                  sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                />
                {remainingPhotos > 0 && (
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      gap: 0.5,
                      bgcolor: "rgba(10, 30, 64, 0.55)",
                      color: "white",
                      backdropFilter: "blur(2px)",
                    }}
                  >
                    <PhotoLibraryOutlinedIcon sx={{ fontSize: 28 }} />
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      +{remainingPhotos} more
                    </Typography>
                  </Box>
                )}
              </Box>
            </Stack>
          </Stack>
        </Paper>

        <Dialog
          open={galleryModalOpen}
          onClose={() => setGalleryModalOpen(false)}
          maxWidth="md"
          fullWidth
          scroll="paper"
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              pr: 1,
              fontWeight: 700,
            }}
          >
            <Typography component="span" variant="h6" sx={{ fontWeight: 700 }}>
              {hotelData.name} Photos ({galleryImages.length})
            </Typography>
            <IconButton
              aria-label="Close gallery"
              onClick={() => setGalleryModalOpen(false)}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              maxHeight: "75vh",
              overflowY: "auto",
              px: { xs: 1.5, sm: 2.5 },
              py: 2,
              bgcolor: tokens.surface,
            }}
          >
            {galleryRows.map((row, rowIndex) => (
              <Box
                key={`gallery-row-${rowIndex}`}
                sx={{
                  display: "flex",
                  flexWrap: "nowrap",
                  justifyContent: "center",
                  alignItems: "stretch",
                  gap: { xs: 1, sm: 1.25 },
                  mb: rowIndex < galleryRows.length - 1 ? { xs: 1, sm: 1.25 } : 0,
                }}
              >
                {row.images?.map((image, imageIndex) => {
                  const photoIndex = row.startIndex + imageIndex;
                  if (!image?.url) return null;

                  return (
                    <Box
                      key={`${image.url}-${photoIndex}`}
                      sx={{
                        ...modalImageTileSx,
                        width: getModalRowItemWidth(row.columnCount),
                        height: getModalImageHeight(row.columnCount),
                      }}
                    >
                      <Box
                        component="img"
                        src={image.url}
                        alt={`${hotelData.name} — photo ${photoIndex + 1}`}
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    </Box>
                  );
                })}
              </Box>
            ))}
          </DialogContent>
        </Dialog>

        {/* Tabs Section */}
        <Paper 
            elevation={0} 
            sx={{
              p: { xs: 2, sm: 3 },
              mb: 3,
              // Removed ml: 8, mr: 8 - Rely on Container padding
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2
            }}
          >
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs 
                value={activeTab} 
                onChange={handleTabChange}
                aria-label="hotel information tabs"
                variant="scrollable" // Make tabs scrollable
                scrollButtons="auto" // Show scroll buttons automatically
                allowScrollButtonsMobile // Ensure scroll buttons show on mobile
                sx={{
                    // px: { xs: 2, sm: 3 }, // Padding might not be needed with scrollable
                    '& .MuiTab-root': {
                      textTransform: 'none',
                      fontSize: '1rem',
                      fontWeight: 500,
                      color: 'text.secondary',
                      '&.Mui-selected': {
                        color: 'primary.main',
                      }
                    }
                  }}
                >
                <Tab label="Rooms & Rates" {...a11yProps(1)} />
                <Tab label="About Hotel" {...a11yProps(2)} />
                {/* <Tab label="Facilities" {...a11yProps(3)} />
                <Tab label="Amenities" {...a11yProps(0)} /> */}
              </Tabs>
            </Box>
            <Box sx={{ px: { xs: 2, sm: 3 }, py: 3 }}>
            <CustomTabPanel value={activeTab} index={2}>
              {/* About Hotel */}
              <Typography variant="h6" sx={{ mb: 3 }}>
                Facilities
              </Typography>
              <Grid container spacing={3}>
                {(searchResults?.details?.facilities || [])
                  .slice(0, 20) // Only take first 20 items
                  .map((facility, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Stack 
                      direction="row" 
                      alignItems="center" 
                      spacing={1}
                      sx={{ 
                        py: 1,
                      }}
                    >
                      <Box
                        sx={{
                          width: 20,
                          height: 20,
                          borderRadius: '50%',
                          bgcolor: tokens.brand,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Typography sx={{ color: 'white', fontSize: '14px' }}>✓</Typography>
                      </Box>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          color: 'text.primary',
                          fontWeight: 600 // Make text bold
                        }}
                      >
                        {facility.name}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={activeTab} index={0}>
  <Box sx={{ p: 0 }}>
    {/* <Typography variant="h6" sx={{ mb: 3, fontWeight: 600, color: "#1a1a1a" }}>
      Available Rooms & Rates
    </Typography> */}

    {/* Filter Section */}
    <Paper 
      elevation={0} 
      sx={{ 
        p: 3, 
        mb: 3, 
        border: `1px solid ${tokens.border}`, 
        borderRadius: 2
      }}
    >
    <Typography 
      sx={{ mb: 2, fontWeight: 600, color: tokens.text, fontSize: "20px" }}
    >  
    <Box
                    component="img"
                    src={filterIcon}
                    alt="Filter"
                    sx={{
                      width: '20px',
                      height: '16px',
                      objectFit: 'contain',
                      mr: 1,
                    }}
                  />
      Filter Rooms
    </Typography>
      
      <Stack 
        direction={{ xs: 'column', md: 'row' }} 
        spacing={3}
        alignItems={{ xs: 'stretch', md: 'flex-end' }}
        sx={{ width: '100%' }}
      >
        {/* Meal Types Filter */}
        <Box sx={{ flex: 1, minWidth: '200px' }}>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
            Meal Types
          </Typography>
          <FormControl fullWidth size="small">
            <Select
              multiple
              value={selectedMealTypes}
              onChange={(e) => setSelectedMealTypes(e.target.value)}
              displayEmpty
              renderValue={(selected) => 
                selected.length === 0 ? 'All meal types' : 
                selected.length === 1 ? selected[0] : 
                `${selected.length} selected`
              }
            >
              {availableMealTypes.map((mealType) => (
                <MenuItem key={mealType} value={mealType}>
                  <Checkbox checked={selectedMealTypes.indexOf(mealType) > -1} />
                  <ListItemText primary={mealType} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Refundable Status Filter */}
        <Box sx={{ flex: 1, minWidth: '180px' }}>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
            Refundable Status
          </Typography>
          <FormControl fullWidth size="small">
            <Select
              multiple
              value={selectedRefundableStatus}
              onChange={(e) => setSelectedRefundableStatus(e.target.value)}
              displayEmpty
              renderValue={(selected) => 
                selected.length === 0 ? 'All statuses' : 
                selected.length === 1 ? selected[0] : 
                `${selected.length} selected`
              }
            >
              {availableRefundableStatus.map((status) => (
                <MenuItem key={status} value={status}>
                  <Checkbox checked={selectedRefundableStatus.indexOf(status) > -1} />
                  <ListItemText primary={status} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Price Range Filter */}
        <Box sx={{ flex: 2, minWidth: '280px' }}>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
            Price Range: ₹{priceRange[0].toLocaleString()} - ₹{priceRange[1].toLocaleString()}
          </Typography>
          <Box sx={{ px: 1 }}>
            <Slider
              value={priceRange}
              onChange={(e, newValue) => setPriceRange(newValue)}
              valueLabelDisplay="auto"
              min={minPrice}
              max={maxPrice}
              step={1000}
              valueLabelFormat={(value) => `₹${value.toLocaleString()}`}
              sx={{
                color: tokens.brand,
                "& .MuiSlider-thumb": {
                  backgroundColor: tokens.brand,
                },
                '& .MuiSlider-track': {
                  backgroundColor: tokens.brand,
                },
                '& .MuiSlider-rail': {
                  backgroundColor: tokens.border,
                },
              }}
            />
          </Box>
        </Box>

        {/* Clear Filters Button */}
        <Box>
          <Button
            variant="outlined"
            onClick={() => {
              setSelectedMealTypes([]);
              setSelectedRefundableStatus([]);
              setPriceRange([0, 1500000]); // Reset to fixed range: 0 to 15 lakh
            }}
            sx={{ 
              textTransform: 'none',
              height: '40px'
            }}
          >
            Clear Filters
          </Button>
        </Box>
      </Stack>
    </Paper>

    {/* Results Count */}
    <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
      Showing {filteredRecommendations.length} of {searchResults?.details?.roomAndRates?.recommendations?.length || 0} room packages
    </Typography>

    {filteredRecommendations.length === 0 ? (
      <Paper elevation={0} sx={{ p: 4, textAlign: "center", border: `1px solid ${tokens.border}` }}>
        <Typography variant="h6" sx={{ mb: 1, color: 'text.secondary' }}>
          No rooms found
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
          Try adjusting your filters to see more results
        </Typography>
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            setSelectedMealTypes([]);
            setSelectedRefundableStatus([]);
            setPriceRange([0, 1500000]); // Reset to fixed range: 0 to 15 lakh
          }}
          sx={{ textTransform: 'none' }}
        >
          Clear All Filters
        </Button>
      </Paper>
    ) : (
      filteredRecommendations.map((recommendation, recIndex) => (
      <Paper
        key={recommendation.recommendationId}
        sx={{
          mb: 3,
          border: `1px solid ${tokens.border}`,
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        {/* Package Header */}
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: tokens.surface,
            borderBottom: `1px solid ${tokens.border}`,
          }}
        >
          <Typography sx={{ fontWeight: 600 }}>
            Room Package {recIndex + 1} ({recommendation.rooms.length} Room
            {recommendation.rooms.length > 1 ? "s" : ""})
          </Typography>
          <Typography sx={{ fontWeight: 600, fontSize: "1.1rem" }}>
            ₹{recommendation.finalRate.toLocaleString()}{" "}
            {/* <Typography
              component="span"
              sx={{ fontWeight: 400, fontSize: "0.85rem", ml: 0.5 }}
            >
              total
            </Typography> */}
                        <Button
                         variant="contained"
                         size="small"
                         ml="1"
                         onClick={() =>
                           handleBookRoom({
                             recommendationId: recommendation.recommendationId,
                             roomId: recommendation.rooms[0].roomId,
                             rateId: recommendation.rooms[0].rateId,
                           })
                         }
                         sx={{ textTransform: "none", ml: 1 }}
                       >
                         Book Now
                       </Button>
          </Typography>
        </Box>

        {/* Rooms Grid Layout - 2 cards per row */}
        <Box sx={{ p: 2 }}>
          <Grid container spacing={2}>
            {recommendation.rooms.map((room, roomIndex) => (
              <Grid 
                item 
                xs={12} 
                sm={6} 
                key={`${room.roomId}-${roomIndex}`}
                sx={{
                  // If it's the 3rd room (index 2), make it take half width on next line
                  ...(roomIndex === 2 && {
                    width: '50%',
                    maxWidth: '50%',
                    flexBasis: '50%'
                  })
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    height: '100%',
                    border: `1px solid ${tokens.border}`,
                    borderRadius: 1,
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      borderColor: 'rgba(0, 113, 194, 0.3)',
                      boxShadow: '0 4px 12px rgba(0, 113, 194, 0.1)'
                    }
                  }}
                >
                  {/* Thumbnail */}
                  <Box sx={{ flex: "0 0 120px", bgcolor: tokens.surface }}>
                    <img
                      src={room.image || "https://images.pexels.com/photos/1470945/pexels-photo-1470945.jpeg?cs=srgb&dl=apartment-architecture-couch-1470945.jpg&fm=jpg"}
                      alt={room.standardizedRoomName}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>

                  {/* Room Details */}
                  <Box sx={{ flex: 1, p: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography sx={{ fontWeight: 600, mb: 0.5 }}>
                        {room.standardizedRoomName}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary", mb: 1 }}
                      >
                        {room.roomName}
                      </Typography>

                      {room.category && (
                        <Box sx={{ mb: { xs: 1.5, sm: 2 } }}>
                          <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap', gap: 0.5 }}>
                            {room.category.split(',').map((cat, idx) => (
                              <Chip
                                key={idx}
                                icon={<CheckCircleIcon sx={{ fontSize: { xs: 12, sm: 14 } }} />}
                                label={cat.trim().replace(/\//g, ' or ')}
                                size="small"
                                sx={{
                                  bgcolor: tokens.successSoft,
                                  color: tokens.success,
                                  fontWeight: 600,
                                  fontSize: { xs: '0.65rem', sm: '0.75rem' },
                                  height: { xs: 24, sm: 26 },
                                  '& .MuiChip-icon': {
                                    color: tokens.success
                                  }
                                }}
                              />
                            ))}
                          </Stack>
                        </Box>
                      )}
                      {/* Refundable Status */}
                      <Box sx={{ mb: { xs: 1.5, sm: 2 } }}>
                        <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap', gap: 0.5 }}>
                          <Chip
                            icon={<CheckCircleIcon sx={{ fontSize: { xs: 12, sm: 14 } }} />}
                            label={room.refundable ? "Refundable" : "Non-Refundable"}
                            size="small"
                            sx={{
                              bgcolor: room.refundable ? tokens.successSoft : tokens.errorSoft,
                              color: room.refundable ? tokens.success : tokens.error,
                              fontWeight: 600,
                              fontSize: { xs: '0.65rem', sm: '0.75rem' },
                              height: { xs: 24, sm: 26 },
                              '& .MuiChip-icon': {
                                color: room.refundable ? tokens.success : tokens.error
                              }
                            }}
                          />
                        {room.freeCancellation && (
                        <Box sx={{ mb: { xs: 1.5, sm: 2 } }}>
                          <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap', gap: 0.5 }}>
                            <Chip
                              icon={<CheckCircleIcon sx={{ fontSize: { xs: 12, sm: 14 } }} />}
                              label={room.freeCancellation}
                              size="small"
                              sx={{
                                bgcolor: tokens.successSoft,
                                color: tokens.success,
                                fontWeight: 600,
                                fontSize: { xs: '0.65rem', sm: '0.75rem' },
                                height: { xs: 24, sm: 26 },
                                "& .MuiChip-icon": {
                                  color: tokens.success,
                                },
                              }}
                            />
                          </Stack>
                        </Box>
                      )}
                        </Stack>
                      </Box>

                      {/* Free Cancellation */}
           

                        <Typography variant="body2" sx={{ mb: 1 }}>
                         {room.beds && room.beds.length > 0 && (
                           <span>
                             {room.beds.map(bed => `${bed.count} ${bed.type}`).join(', ')} •{' '}
                           </span>
                         )}
                         {Array.isArray(room.occupancies)
                           ? room.occupancies.reduce(
                               (a, occ) => a + (parseInt(occ.numOfAdults) || 0),
                               0
                             )
                           : 0}{" "}
                         Adults
                         {Array.isArray(room.occupancies) &&
                           room.occupancies.reduce(
                             (a, occ) => a + (parseInt(occ.numOfChildren) || 0),
                             0
                           ) > 0 &&
                           `, ${
                             room.occupancies.reduce(
                               (a, occ) => a + (parseInt(occ.numOfChildren) || 0),
                               0
                             )
                           } Children`}
                       </Typography>

                      {/* Facilities */}
                      {room.facilities && room.facilities.length > 0 && (
                        <Box sx={{ mt: { xs: 1, sm: 1.5 }, mb: 1 }}>
                          <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap', gap: 0.5 }}>
                            {room.facilities.slice(0, 3).map((facility, idx) => (
                              <Chip
                                key={idx}
                                label={facility}
                                size="small"
                                sx={{
                                  bgcolor: 'rgba(0, 113, 194, 0.08)',
                                  color: tokens.brand,
                                  fontWeight: 500,
                                  fontSize: { xs: '0.65rem', sm: '0.75rem' },
                                  height: { xs: 22, sm: 24 }
                                }}
                              />
                            ))}
                          </Stack>
                        </Box>
                      )}

           

                      {room.cancellationPolicies?.text && (
                        <Typography
                          variant="caption"
                          sx={{ display: "block", color: "success.main", mb: 1 }}
                        >
                          Cancellation: {room.cancellationPolicies.text}
                        </Typography>
                      )}
                    </Box>

                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Paper>
      ))
    )}
  </Box>
</CustomTabPanel>


            <CustomTabPanel value={activeTab} index={3}>
              <Typography variant="h6" sx={{ mb: 3 }}>
                Hotel Amenities
              </Typography>
              <Grid container spacing={3}>
                {(searchResults?.details?.amenities || [])
                  .slice(0, 20) // Only take first 20 items
                  .map((amenity, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Stack 
                      direction="row" 
                      alignItems="center" 
                      spacing={1}
                      sx={{ 
                        py: 1,
                      }}
                    >
                      <Box
                        sx={{
                          width: 20,
                          height: 20,
                          borderRadius: '50%',
                          bgcolor: tokens.brand,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Typography sx={{ color: 'white', fontSize: '14px' }}>✓</Typography>
                      </Box>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          color: 'text.primary',
                          fontWeight: 600 // Make text bold
                        }}
                      >
                        {amenity.name}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </CustomTabPanel>

            <CustomTabPanel value={activeTab} index={1}>
              <Box sx={{ p: 2 }}>
                {/* Check-in/Check-out Information */}
                <Box sx={{ mb: 4 }}>
                  <Typography variant="h6" sx={{ mb: 2, color: tokens.brand }}>
                    Check-in/Check-out Information
                  </Typography>
                  <Paper 
                    elevation={0} 
                    sx={{ 
                      p: 3, 
                      bgcolor: 'rgba(0, 113, 194, 0.04)', 
                      borderRadius: 2,
                      display: 'flex',
                      flexDirection: { xs: 'column', md: 'row' },
                      gap: 4
                    }}
                  >
                    {/* Check-in Details */}
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                        Check-in Time
                      </Typography>
                      <Stack spacing={1}>
                        <Typography variant="body1">
                          From {searchResults?.details?.aboutHotel?.checkinInfo?.beginTime || "3:00 PM"} to {searchResults?.details?.aboutHotel?.checkinInfo?.endTime || "midnight"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          • Minimum check-in age: 18
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          • Government-issued photo ID required
                        </Typography>
                      </Stack>
                    </Box>

                    {/* Check-out Details */}
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                        Check-out Time
                      </Typography>
                      <Typography variant="body1">
                        Before {searchResults?.details?.aboutHotel?.checkoutInfo?.time || "12:00 PM"}
                      </Typography>
                    </Box>
                  </Paper>
                </Box>

                {/* Contact Information */}
                <Box sx={{ mb: 4 }}>
                  <Typography variant="h6" sx={{ mb: 2, color: tokens.brand }}>
                    Hotel Contact Details
                  </Typography>
                  <Paper 
                    elevation={0} 
                    sx={{ 
                      p: 3, 
                      bgcolor: 'rgba(0, 113, 194, 0.04)', 
                      borderRadius: 2 
                    }}
                  >
                    <Stack spacing={3}>
                      {/* Address */}
                      <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                          Address
                        </Typography>
                        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                          {searchResults?.details?.aboutHotel?.contact?.address?.line1},{" "} 
                          
                          {searchResults?.details?.aboutHotel?.contact?.address?.city?.name},{" "}
                          {searchResults?.details?.aboutHotel?.contact?.address?.state?.name},
                          {" "}
                          {searchResults?.details?.aboutHotel?.contact?.address?.country?.name} - {searchResults?.details?.aboutHotel?.contact?.address?.postalCode}
                        </Typography>
                      </Box>

                      {/* Contact Numbers */}
                      <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                          Contact Numbers
                        </Typography>
                        <Stack spacing={1}>
                          {searchResults?.details?.aboutHotel?.contact?.phones?.[0] && (
                            <Typography variant="body1">
                              Phone: {searchResults?.details?.aboutHotel?.contact?.phones[0]}
                            </Typography>
                          )}
                          {searchResults?.details?.aboutHotel?.contact?.fax?.[0] && (
                            <Typography variant="body1">
                              Fax: {searchResults?.details?.aboutHotel?.contact?.fax[0]}
                            </Typography>
                          )}
                        </Stack>
                      </Box>
                    </Stack>
                  </Paper>
                </Box>

                {/* Property Policies */}
                <Box sx={{ mb: 4 }}>
                  <Typography variant="h6" sx={{ mb: 2, color: tokens.brand }}>
                    Property Policies
                  </Typography>
                  <Paper 
                    elevation={0} 
                    sx={{ 
                      p: 3, 
                      bgcolor: 'rgba(0, 113, 194, 0.04)', 
                      borderRadius: 2 
                    }}
                  >
                    <Stack spacing={3}>
                      {/* Special Instructions */}
                      {searchResults?.details?.aboutHotel?.checkinInfo?.specialInstructions?.[0] && (
                        <Box>
                          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                            Special Instructions
                          </Typography>
                          <Typography 
                            variant="body1" 
                            sx={{ 
                              color: 'text.primary',
                              lineHeight: 1.8,
                              '& ul': { 
                                paddingLeft: 2,
                                marginTop: 1,
                                '& li': { 
                                  marginBottom: 1 
                                } 
                              } 
                            }}
                            dangerouslySetInnerHTML={{ 
                              __html: searchResults?.details?.aboutHotel?.checkinInfo?.specialInstructions[0] 
                            }}
                          />
                        </Box>
                      )}

                      {/* Check-in Instructions */}
                      {searchResults?.details?.aboutHotel?.checkinInfo?.instructions?.[0] && (
                        <Box>
                          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                            Check-in Instructions
                          </Typography>
                          <Typography 
                            variant="body1" 
                            sx={{ 
                              color: 'text.primary',
                              lineHeight: 1.8,
                              '& ul': { 
                                paddingLeft: 2,
                                marginTop: 1,
                                '& li': { 
                                  marginBottom: 1 
                                } 
                              } 
                            }}
                            dangerouslySetInnerHTML={{ 
                              __html: searchResults?.details?.aboutHotel?.checkinInfo?.instructions[0] 
                            }}
                          />
                        </Box>
                      )}
                    </Stack>
                  </Paper>
                </Box>
              </Box>
            </CustomTabPanel>
          </Box>
          </Box>
        </Paper>
      </Container>
      <TravelersModal
        isOpen={openTravelersModal}
        handleClose={() => setOpenTravelersModal(false)}
        onTravelersChange={handleTravelersChange}
      />
    </Box>
    </>
  );
};

export default HotelDetailsPage;